import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AttachmentSphere } from '@models/events/enums/attachment-sphere-enum';
import { IResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { PageRequest } from '@models/pagination/page-request';
import { IAttachmentTypeDto } from '@models/portal/users/dtos/attchment-type-dto';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { Observable } from 'rxjs';
import { toParams } from 'src/app/core/utilities/utility-functions';

@Injectable({
  providedIn: 'root'
})
export class AttachmentTypeService {

  #baseUrl = environment.apiUrl.concat('/v1/tipos-anexos')

  #http = inject(HttpClient);

  fetchAttachmentTypes$(pageRequest: PageRequest, tipTxEsfera: AttachmentSphere): Observable<IPage<IAttachmentTypeDto>> {
    return this.#http.get<IResponseDto<IPage<IAttachmentTypeDto>>>(this.#baseUrl, { params: toParams(pageRequest, { tipTxEsfera }) }).pipe(extractResponse());
  }
}
